// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/ui-core/skeleton.tmpl.tsx
// Parameters       : infra/fleet/registry/repos.ts  (entry "folio-office-app")
// Destination      : packages/fleet/ui/src/skeleton.tsx
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo folio-office-app
//     node fleet/fleet.ts check --repo folio-office-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { type Component, type ComponentProps, splitProps } from "solid-js";
import { cn } from "@folio/shared";

const Skeleton: Component<ComponentProps<"div">> = (props) => {
  const [local, rest] = splitProps(props, ["class"]);
  return <div class={cn("animate-shimmer rounded-md", local.class)} {...rest} />;
};

export { Skeleton };
